import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Table, Form, Modal } from 'react-bootstrap';
import Layout from "../../../layout/default";
import { Link } from "react-router-dom";
import Block from "../../../components/Block/Block";

const CommissionDetails = () => {
    const [details, setDetails] = useState([]);
    const [commissions, setCommissions] = useState([]); // Store commissions from API
    const [showModal, setShowModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [formData, setFormData] = useState({
        comission_id: '',
        level: '',
        commission: ''
    });
    const [selectedDetail, setSelectedDetail] = useState(null);

    const fetchDetails = async () => {
        try {
            const authToken = localStorage.getItem('authToken');
            const response = await axios.get(`${process.env.REACT_APP_HOST}api/comission-details`, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });
            setDetails(response.data);
        } catch (error) {
            console.error('Error fetching commission details:', error);
        }
    };

    const fetchCommissions = async () => {
        try {const authToken = localStorage.getItem('authToken');
            const response = await axios.get(`${process.env.REACT_APP_HOST}api/comissions`,{
                headers: {
                    Authorization: `Bearer ${authToken}`
                },
        });
            setCommissions(response.data);
        } catch (error) {
            console.error('Error fetching commissions:', error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const authToken = localStorage.getItem('authToken');
            if (isEdit && selectedDetail) {
                await axios.put(`${process.env.REACT_APP_HOST}api/comission-details/${selectedDetail.id}`, formData, {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                });
            } else {
                await axios.post(`${process.env.REACT_APP_HOST}api/comission-details`, formData, {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                });
            }
            setShowModal(false);
            fetchDetails();
        } catch (error) {
            console.error('Error saving commission detail:', error);
        }
    };

    const handleDelete = async (id) => {
        try {
            const authToken = localStorage.getItem('authToken');
            await axios.delete(`${process.env.REACT_APP_HOST}api/comission-details/${id}`, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });
            fetchDetails();
        } catch (error) {
            console.error('Error deleting commission detail:', error);
        }
    };

    const handleOpenModal = (detail = null) => {
        if (detail) {
            setIsEdit(true);
            setSelectedDetail(detail);
            setFormData({
                comission_id: detail.comission_id,
                level: detail.level,
                commission: detail.commission
            });
        } else {
            setIsEdit(false);
            setFormData({
                comission_id: '',
                level: '',
                commission: ''
            });
        }
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    useEffect(() => {
        fetchDetails();
        fetchCommissions();
    }, []);

    return (
        <Layout title="Commission Details">
            <Block.HeadContent>
                <ul className="d-flex">
                    <li>
                        <Link
                            to="/shop/admin/admin-panel"
                            className="btn btn-primary btn-md d-md-none"
                        >
                            <span>Go To Panel</span>
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/shop/admin/admin-panel"
                            className="btn btn-primary d-none d-md-inline-flex"
                        >
                            <span>Go To Panel</span>
                        </Link>
                    </li>
                </ul>
            </Block.HeadContent>
            <div className="mb-4" style={{ marginTop: '20px' }}>
                <Button
                    variant="primary"
                    onClick={() => handleOpenModal()}
                    className="mb-3"
                >
                    Add Commission Detail
                </Button>

                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>Minimum Order</th>
                            <th>Level</th>
                            <th>Commission</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {details.map((detail) => {
                            const matchingCommission = commissions.find(
                                (commission) => commission.id === detail.comission_id
                            );
                            return (
                                <tr key={detail.id}>
                                    <td>
                                        {matchingCommission
                                            ? `Minimum Order: ${matchingCommission.minimum_order}`
                                            : 'Not Found'}
                                    </td>
                                    <td>{detail.level}</td>
                                    <td>{detail.commission}</td>
                                    <td>
                                        <Button
                                            variant="warning"
                                            onClick={() => handleOpenModal(detail)}
                                            className="me-2"
                                        >
                                            Edit
                                        </Button>
                                        <Button
                                            variant="danger"
                                            onClick={() => handleDelete(detail.id)}
                                        >
                                            Delete
                                        </Button>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </div>

            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{isEdit ? 'Edit Commission Detail' : 'Add Commission Detail'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="comission_id" className="mb-3">
                            <Form.Label>Select Commission</Form.Label>
                            <Form.Control
                                as="select"
                                name="comission_id"
                                value={formData.comission_id}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select a commission</option>
                                {commissions.map((commission) => (
                                    <option key={commission.id} value={commission.id}>
                                        {`Minimum Order: ${commission.minimum_order}`}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group controlId="level" className="mb-3">
                            <Form.Label>Level</Form.Label>
                            <Form.Control
                                type="number"
                                name="level"
                                value={formData.level}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="commission" className="mb-3">
                            <Form.Label>Commission</Form.Label>
                            <Form.Control
                                type="number"
                                name="commission"
                                value={formData.commission}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>
                        <Button variant="primary" type="submit">
                            {isEdit ? 'Save Changes' : 'Add Commission'}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </Layout>
    );
};

export default CommissionDetails;
